import { Button } from "reactstrap";

import { default as utilIcons } from "../resources/utilIcons";
import { colors } from "../styles/colors";
import "../styles/HeaderSortButtons.css";

function HeaderSortButtons({ sortCallback, sortValue, currentSort }) {
	const handleAsc = () => {
		sortCallback(sortValue, "Asc");
	};

	const handleDesc = () => {
		sortCallback(sortValue, "Desc");
	};

	const getDisplayState = () => {
		if (currentSort?.length === 1 && currentSort[0][0] === sortValue) {
			switch (currentSort[0][1]) {
				case "Asc":
					return " ascending";
				case "Desc":
					return " descending";
				default:
					return "";
			}
		}
        return "";
	};

	return (
		<div className={"header-sort-buttons" + getDisplayState()}>
			<Button className="header-sort-asc" onClick={handleAsc}>
				{utilIcons.caret(colors["ars-neutral-900"], {
					rotate: "180deg",
				})}
			</Button>
			<Button className="header-sort-desc" onClick={handleDesc}>
				{utilIcons.caret(colors["ars-neutral-900"])}
			</Button>
		</div>
	);
}

export default HeaderSortButtons;
